import { render, staticRenderFns } from "./veStuScholarshipTypeShow.vue?vue&type=template&id=36120e2c&scoped=true"
import script from "./veStuScholarshipTypeShow.vue?vue&type=script&lang=js"
export * from "./veStuScholarshipTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36120e2c",
  null
  
)

export default component.exports